<template>
  <div class="system-curve-wrap">

    <system-curve-item
        :active="currentSelectedIndex === index"
        v-for="(item,index) in recommendCurves"
        @click="click(item,index)"
        @onFavoriteClick="onFavoriteClick(item,index)"
        :curve-item="item"
        :key="index"/>
  </div>
</template>


<script>
import SystemCurveItem from "@/components/home/SystemCurveItem.vue";
import device from "@/api/device";
import user from "@/api/user";

export default {
  name: "SystemCurve",
  components: { SystemCurveItem },
  props: {
    tagId: {
      type: String,
      default: ""
    },
    curves: {
      type: Array,
      default: () => {
        return [];
      }
    },

    currentSelectedIndex: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      recommendCurves: []
    };
  },
  methods: {
    click(item, index) {
      this.$emit("click", item, index);
    },
    async onFavoriteClick(item, index) {
      // this.currentSelectedIndex = index;
      this.$emit("onFavoriteClick", item,index);
      try {
        const resp = await user.favoriteRecommendCurve({
          id: item.id,
          isFavorite: item.isFavorite ? 0 : 1
        }, true);
        if (resp.code != 200) {
          this.$toast({
            type: "fail",
            message: e
          });
          return;
        }
        this.$toast({
          type: "success",
          message: resp.message
        });

        item.isFavorite = item.isFavorite ? 0 : 1;
        const isFavorite = item.isFavorite === 1;
        if (isFavorite) {
          item.favoriteCount += 1;
        } else {
          item.favoriteCount -= 1;
        }
        this.$set(this.recommendCurves, index, item);
      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }
    }
  },
  watch: {
    curves(val) {
      this.recommendCurves = val;
    }
  },
  async mounted() {
    this.recommendCurves = this.curves;
  }
};
</script>

<style scoped lang="less">
.system-curve-wrap {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  overflow: scroll;
}
</style>